import type { Column } from "@tanstack/react-table";
import { cn } from "@/lib/utils";

interface Props<TData, TValue> {
  column: Column<TData, TValue>;
  title: string;
  align?: "left" | "right";
  className?: string;
}

export function DataTableColumnHeader<TData, TValue>({ column, title, align = "left", className }: Props<TData, TValue>) {
  if (!column.getCanSort()) {
    return <span className={cn(align === "right" && "block text-right", className)}>{title}</span>;
  }
  const sorted = column.getIsSorted();
  return (
    <button
      type="button"
      aria-label={`Sort by ${title}`}
      onClick={() => column.toggleSorting(sorted === "asc")}
      className={cn(
        "inline-flex h-full items-center gap-1.5 font-medium text-muted-foreground hover:text-foreground",
        sorted && "font-semibold text-brand hover:text-brand",
        align === "right" && "w-full justify-end",
        className
      )}
    >
      {title}
      <span
        aria-hidden
        className={cn(
          "inline-block size-0 border-x-[3.5px] border-x-transparent",
          sorted === "asc" && "border-b-[4px] border-b-current",
          sorted === "desc" && "border-t-[4px] border-t-current",
          !sorted && "invisible border-t-[4px] border-t-current"
        )}
      />
    </button>
  );
}
